import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from 'reactstrap'
import toast from 'react-hot-toast'

import { DiningMethodSelector, Loader, TableSelector } from '@components'
import { DINING_METHOD_OPTIONS, ROUTES } from '@common'
import { useCartRedux, useDashboardRedux, useUserRedux } from '@hooks'

export default function HomePage() {
    const navigate = useNavigate()
    const { diningMethod, tableId, setDiningMethod, setTableId } = useUserRedux()
    const { isLoading: isDashboardLoading, tables, fetchCafeConfig } = useDashboardRedux()
    const { clearCart } = useCartRedux()

    useEffect(() => {
        clearCart()
        fetchCafeConfig()
        // eslint-disable-next-line
    }, [])

    const onCheckOrderStatus = () => {
        navigate(ROUTES.Order.search)
    }

    const onViewMenu = () => {
        if (diningMethod.value === DINING_METHOD_OPTIONS[0].value && !tableId) {
            toast.error('Please provide your table number')
        } else {
            navigate(ROUTES.Table.root)
        }
    }

    const onDiningMethodChange = value => {
        setDiningMethod(value)
        setTableId(null)
    }

    return (
        <div className="home-page">
            {isDashboardLoading && <Loader />}
            <div className="d-flex align-items-center justify-content-between">
                <h1>Welcome to Kopi +</h1>
            </div>
            <h5 className="mt-4" style={{ color: '#3670A3' }}>
                Note: You can order from multiple stalls in a single checkout and make a single payment at the Drink Stall cashier
                or via Paynow.
            </h5>
            <DiningMethodSelector mode="Dropdown" onChange={onDiningMethodChange} containerClassName="mt-5" />
            {diningMethod.value === 'DineIn' && (
                <TableSelector
                    items={tables.map(table => ({ value: table.id, label: table.name }))}
                    onChange={setTableId}
                    containerClassName="mt-3"
                />
            )}
            <div className="button-container">
                <Button color="primary" className="w-100" onClick={onViewMenu}>
                    View Menu
                </Button>
                <p className="text-check-order-status text-primary" onClick={onCheckOrderStatus}>
                    Check Order Status
                </p>
            </div>
        </div>
    )
}
